import TooltipButton from '../TooltipButton.vue';


export default {
  __name: 'VariationsField',
  props: {
    selectedVariation: {
        type: Number,
        required: true,
    },
    variations: {
        type: Array,
        required: true,
    },
    selectVariation: {
        type: Function,
        required: false,
    },
    name: {
        type: String,
        required: false,
    },
    tooltip: {
        type: String,
        required: false,
        default: '',
    },
},
  setup(__props, { expose }) {
  expose();

const props = __props;



const __returned__ = { props, TooltipButton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}